import { useQuery } from '@tanstack/react-query';
import { GET_OCCASIONS } from '@/constants/API';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { API_RESPONSE } from '@/types/api';
import { Occasions } from '@/types/occasion';
import storage from '@/utils/storage';

export const getOccasion = async (params: any) => {
  if (params === undefined) {
    const currentLocation = storage.getItem('currentLocation');
    if (currentLocation) {
      params = { location_id: currentLocation.id };
    }
  }

  try {
    const data = await axios.get<API_RESPONSE<Occasions[]>>(GET_OCCASIONS, { params });
    return data.data;
  } catch (error) {}
};

type UpdateConfigQueryFnType = typeof getOccasion;

type UseUpdateConfigOptions = {
  params?: any;
  config?: QueryConfig<UpdateConfigQueryFnType>;
};

export const useOccasion = ({ config, params }: UseUpdateConfigOptions) =>
  useQuery<ExtractFnReturnType<UpdateConfigQueryFnType>>({
    ...config,
    queryKey: ['occasion'],
    queryFn: async () => await getOccasion(params),
  });
